import { services } from '@/configs/translates.config'
export default {
	'add-new-service': `add new ${services.en.singular}`,
	'the-service': `the ${services.en.singular}?`,
	services: services.en.singular,
}